export default [
  { text: "Місяць/рік", align: "left", value: "mounth", sortable: false },
  {
    text: "На початок місяця, години",
    align: "right",
    value: "startMonthBalance",
    sortable: false,
  },
  {
    text: "Оплата, години",
    align: "right",
    value: "payedHours",
    sortable: false,
  },
  {
    text: "Робота, години",
    align: "right",
    value: "spentHours",
    sortable: false,
  },
  {
    text: "Сервіси",
    align: "right",
    value: "servicesHours",
    sortable: false,
  },
  {
    text: "Бонуси, години",
    align: "right",
    value: "bonusHours",
    sortable: false,
  },
  {
    text: "На кінець місяця, години",
    align: "right",
    value: "endMonthBalance",
    sortable: false,
  },
];
